import { FormatterType, FormFieldId, IOlavEntry, SearchableFieldId } from '@mwe/models';

export const searchableFields: SearchableFieldId[] = ['zipCode', 'street', 'building', 'door'];
export const fieldFlow: Record<FormFieldId, FormFieldId | null> = {
  zipCode: 'street',
  location: null,
  street: 'building',
  building: 'door',
  door: null,
};

export const dependencyMap: Record<FormFieldId, FormFieldId | null> = {
  zipCode: 'location',
  location: null,
  street: 'building',
  building: 'door',
  door: null,
};

export const formatterConfig: Record<FormFieldId, Record<FormatterType, (doc: IOlavEntry) => string>> = {
  zipCode: {
    input: doc => doc?.plz ?? '',
    result: doc => `${doc?.plz} ${doc?.gemeinde}`,
  },
  location: {
    input: doc => doc?.gemeinde ?? '',
    result: doc => doc?.gemeinde ?? '',
  },
  street: {
    input: doc => doc?.strasse ?? '',
    result: doc => doc?.strasse ?? '',
  },
  building: {
    input: doc => doc?.gebadr1 ?? '',
    result: doc => doc?.gebadr1 ?? '',
  },
  door: {
    input: doc => doc?.tuerNr ?? '',
    result: doc => doc?.tuerNr ?? '',
  },
};
